module.exports = __webpack_public_path__ + "static/img/cDR1.685c11ba.png";